import { onDomReady } from "../../components/dynamic/observer";
import { Swiper } from 'swiper';
import {EffectCreative, EffectFade, Navigation} from 'swiper/modules';
import '../../../node_modules/swiper/swiper.scss';
import '../../../node_modules/swiper/modules/pagination.min.css';

// Обратите внимание - модули подрубаются отдельным импортом из swiper/modules

function init() {
    const container = document.querySelector('[data-history-slider-container]');

    if (!container) return;

    const textSliderElement = container.querySelector('[data-history-slider]');
    const yearSliderElement = container.querySelector('[data-history-year-slider]');
    const timelineSliderElement = container.querySelector('[data-history-timeline-slider]');

    if (!textSliderElement || !yearSliderElement || !timelineSliderElement) {
        return;
    }

    const prevArrow = container.querySelector('[data-history-slider-prev]');
    const nextArrow = container.querySelector('[data-history-slider-next]');

    const animationSpeed = 800;

    const textSlider = new Swiper(textSliderElement, {
        modules: [Navigation, EffectCreative],
        navigation: {
            prevEl: prevArrow,
            nextEl: nextArrow,
        },
        effect: "creative",
        allowTouchMove: false,
        speed: animationSpeed,
        creativeEffect: {
            prev: {
                opacity: 0,
                scale: 1.01
            },
            next: {
                opacity: 0,
                scale: 1.01
            },
        }
    });

    const yearSlider = new Swiper(yearSliderElement, {
        allowTouchMove: false,
        speed: animationSpeed,
        breakpoints: {
            1200: {
                direction: "vertical",
            }
        },
    });
    const timelineSlider = new Swiper(timelineSliderElement, {
        allowTouchMove: false,
        speed: animationSpeed,
        slidesPerView: "auto",
        spaceBetween: 25
    });

    textSlider.on('slideChange', () => {
        yearSlider.slideTo(textSlider.activeIndex);
        timelineSlider.slideTo(textSlider.activeIndex);
    })
}

onDomReady(init);